import { Controller } from "@hotwired/stimulus"
import PhotoSwipeLightbox from "photoswipe/lightbox"

export default class extends Controller {
  connect() {
    this.lightbox = new PhotoSwipeLightbox({
      gallery: this.element,
      children: ".panels-button",
      pswpModule: () => import("photoswipe")
    })

    this.lightbox.init()
  }

  disconnect() {
    this.lightbox.destroy()
    this.lightbox = null
  }
}
